/**
 * URL base de la API (fan site o mismo origen).
 * Cuando se configura VITE_API_URL, /ar/invitacion usa esa API para validar códigos.
 * Fallback: mismo origen (para desarrollo o cuando la API está en este proyecto).
 */
export function getApiBaseUrl(): string {
  const env = import.meta.env.VITE_API_URL as string | undefined;
  if (env && typeof env === "string" && env.trim()) {
    return env.trim().replace(/\/+$/, "");
  }
  return typeof window !== "undefined" ? window.location.origin : "";
}

/** True si VITE_API_URL está definida (API externa disponible). */
export function isApiUrlConfigured(): boolean {
  const env = import.meta.env.VITE_API_URL as string | undefined;
  return !!(env && typeof env === "string" && env.trim());
}
